export default __webpack_public_path__ + "static/media/Best area.9e451060.gif";